<template>
  <div class="other-container-l">

    <div class="smaller-menu-tabs">
      <label for="tab1" class="filter-label" :class="{'is-selected': (tab == 'online')}" v-on:click="tab = 'online'">Online uplata</label>
      <label for="tab2" class="filter-label" :class="{'is-selected': (tab == 'banktransfer')}" v-on:click="tab = 'banktransfer'">Uplata općom uplatnicom</label>
      <label for="tab3" class="filter-label" :class="{'is-selected': (tab == 'shop')}" v-on:click="tab = 'shop'">Uplata u poslovnici</label>
      <img class="close-modal" src="../../assets/img/close.svg">
      </div>

    <div class="pages-left-container">
      <div class="content-container pages-container" v-if="!success">

        <!-- ONLINE DEPOSIT -->
        <div  v-if="tab == 'online'">
          <div class="deposit-online">
            <h2>Online uplata sredstva na račun</h2>
            <p>Kod uplata kreditnim i debitnim karticama koristite CorvusPay, napredan sustav za siguran prihvat platnih kartica putem interneta (saznajte više o sigurnosti CorvusPay sustava).</p>
            <div class="input-box mt-xlg">
              <label>Iznos za uplatu:</label> <input type="text" class="input-text" placeholder="Value" v-model="depositAmount">
            </div>
            <p>Molimo Vas da upišete iznos koji želite uplatiti na Vaš račun. U nastavku izaberite način plaćanja.</p>

            <hr class="content-line mb-xlg mt-xlg">

            <div class="depositonline-methods mb-xlg">
              <div class="visa">
                <img src="../../assets/img/payment-visa.svg">
                <input type="checkbox" class="input-checkbox full"><span class="checkmark"></span>
              </div>
              <div class="skrill">
                <img src="../../assets/img/payment-skrill.svg">
                <input type="checkbox" class="input-checkbox full"><span class="checkmark"></span>
              </div>
              <div class="paysafecard">
                <img src="../../assets/img/payment-paysafe.svg">
                <input type="checkbox" class="input-checkbox full"><span class="checkmark"></span>
              </div>
              <div class="mastercard">
                <img src="../../assets/img/payment-mastercard.svg">
                <input type="checkbox" class="input-checkbox full"><span class="checkmark"></span>
              </div>
              <div class="maestro">
                <img src="../../assets/img/payment-maestro.svg">
                <input type="checkbox" class="input-checkbox full"><span class="checkmark"></span>
              </div>
              <div class="neteller">
                <img src="../../assets/img/payment-neteller.svg">
                <input type="checkbox" class="input-checkbox full"><span class="checkmark"></span>
              </div>
            </div>

            <div class="input-box">
              <label>Upišite podatke sa kartice:</label> <input type="text" class="input-text mr-lg" placeholder="Name written on the card"><input type="text" class="input-text small" placeholder="Month">
            </div>
            <div class="input-box">
              <input type="text" class="input-text mr-lg" placeholder="Credit card number"><input type="text" class="input-text small" placeholder="Year">
            </div>
            <div class="input-box">
              <input type="text" class="input-text mr-lg small" placeholder="CVV2">
              <span>
                <img src="../../assets/img/help.svg">
                <img src="../../assets/img/credit-card.svg">
              </span>
            </div>

            <form action="" class="deposit-buttons-form">
              <!-- a href="" class="button button-grey-first mr-lg button-cancel">Odustani</a -->
              <a href="#" v-on:click.stop="deposit" class="button button-blue button-continue">{{$t('CONTINUE')}}</a>
              <p class="text-danger">{{error}}</p>
            </form>
          </div>
        </div>

        <!-- ONLINE DEPOSIT END -->

        <!-- BANK TRANSFER -->
        <div  v-if="tab == 'banktransfer'">
          <div class="banktransfer">
            <h2>Uplata općom uplatnicom</h2>
            <p>Uplatite sredstva na svoj Demobet internet račun općom uplatnicom. Demobet će vam staviti uplatu na raspolaganje čim se transakcija provede. Ako vam iznos nije raspoloživ za 2 radna dana, <a href="#">kontaktirajte našu službu za korisnike</a>.</p>

            <h3 class="mt-xlg">Za uplate općom uplatnicom koristite sljedeće podatke:</h3>
            <p><span>IBAN: </span>HR9385893856329483274</p>
            <p><span>Primatelj: </span>Demobet Sportska kladionica</p>
            <p><span>Adresa: </span>Savska opatovina 36, 10000 Zagreb</p>
            <p><span>Svrha uplate (upišite svoj broj Demobet računa): </span>836284628</p>

            <hr class="content-line mb-xlg mt-xlg">

            <p><span>Banka: </span>Erste banka d.d. Rijeka</p>

            <hr class="content-line mb-xlg mt-xlg">

            <p><span>Swift: </span>32432RW87</p>

            <hr class="content-line mb-xlg mt-xlg">

            <p class="content-note">NAPOMENA: Uplatu obavite u hrvatskim kunama (HRK).</p>
          </div>
        </div>
        <!-- BANK TRANSFER END -->

        <div  v-if="tab == 'shop'">
          <div class="shop">
            <h2>Uplata u poslovnici</h2>
            <p>Uplatite sredstva na svoj Demobet internet račun u bilo kojoj poslovnici. <br>Samo predajte blagajnici željeni iznos i svoj poziv na broj:
            <span>836284628</span></p>
            <hr class="content-line mb-xlg mt-xlg">
            <div class="input-box mt-xlg">
              <label>Izaberite sa liste poslovnicu kako bi vidjeli adresu poslovnice:</label> <input type="text" class="input-text" placeholder="List of shops">
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>{{$t('SUCCESS')}}</p>
      </div>

    </div>

    <div class="pages-promotions-sidebar">
      <img src="../../assets/img/promotion-1.png">
      <img src="../../assets/img/promotion-2.png">
      <!--<img src="../../assets/img/promotion-3.png">-->
    </div>

  </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';
import Api from '../api/Player';

export default {
    name: 'Deposit',
    components: {

    },
    data()
    {
        return {
            tab: 'online',
            depositAmount: 0,
            error: '',
            success: false,
        };
    },
    computed: {
        ...mapGetters([
            'globals',
            'isMobile',
        ]),
    },
    methods:
    {
        async deposit()
        {
            const me = this;

            me.errors = '';

            const data = await Api.deposit({
                amount: me.depositAmount,
            });

            if (data.error)
            {
                me.error = data.code;
            }
            else
            {
                me.success = true;
            }
        },
    },
};
</script>
